import { render, staticRenderFns } from "./invite-user.vue?vue&type=template&id=4b458414&scoped=true&"
import script from "./invite-user.vue?vue&type=script&lang=js&"
export * from "./invite-user.vue?vue&type=script&lang=js&"
import style0 from "./invite-user.vue?vue&type=style&index=0&id=4b458414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b458414",
  null
  
)

export default component.exports